var map = {
	"./4icon／缺省页／loading@2x.png": "./src/assets/newicons/4icon／缺省页／loading@2x.png",
	"./del11.png": "./src/assets/newicons/del11.png",
	"./i001.png": "./src/assets/newicons/i001.png",
	"./i002.png": "./src/assets/newicons/i002.png",
	"./ia01.png": "./src/assets/newicons/ia01.png",
	"./ia02.png": "./src/assets/newicons/ia02.png",
	"./ia03.png": "./src/assets/newicons/ia03.png",
	"./ia04.png": "./src/assets/newicons/ia04.png",
	"./ia05.png": "./src/assets/newicons/ia05.png",
	"./ia06-gray.png": "./src/assets/newicons/ia06-gray.png",
	"./ia06.png": "./src/assets/newicons/ia06.png",
	"./ia07.png": "./src/assets/newicons/ia07.png",
	"./ib01.png": "./src/assets/newicons/ib01.png",
	"./ib02.png": "./src/assets/newicons/ib02.png",
	"./ib03.png": "./src/assets/newicons/ib03.png",
	"./ic01.png": "./src/assets/newicons/ic01.png",
	"./id01.png": "./src/assets/newicons/id01.png",
	"./id02.png": "./src/assets/newicons/id02.png",
	"./ii01.png": "./src/assets/newicons/ii01.png",
	"./ik01.png": "./src/assets/newicons/ik01.png",
	"./io01.png": "./src/assets/newicons/io01.png",
	"./iu01.png": "./src/assets/newicons/iu01.png",
	"./iu02.png": "./src/assets/newicons/iu02.png",
	"./iu03.png": "./src/assets/newicons/iu03.png",
	"./iu04.png": "./src/assets/newicons/iu04.png",
	"./iu11.png": "./src/assets/newicons/iu11.png",
	"./iu12.png": "./src/assets/newicons/iu12.png",
	"./iu13.png": "./src/assets/newicons/iu13.png",
	"./iu14.png": "./src/assets/newicons/iu14.png",
	"./logo.png": "./src/assets/newicons/logo.png",
	"./nav01.png": "./src/assets/newicons/nav01.png",
	"./nav01_ok.png": "./src/assets/newicons/nav01_ok.png",
	"./nav02.png": "./src/assets/newicons/nav02.png",
	"./nav02_ok.png": "./src/assets/newicons/nav02_ok.png",
	"./nav03.png": "./src/assets/newicons/nav03.png",
	"./nav03_ok.png": "./src/assets/newicons/nav03_ok.png",
	"./nav04.png": "./src/assets/newicons/nav04.png",
	"./nav04_ok.png": "./src/assets/newicons/nav04_ok.png",
	"./o01.png": "./src/assets/newicons/o01.png",
	"./o02.png": "./src/assets/newicons/o02.png",
	"./o03.png": "./src/assets/newicons/o03.png",
	"./search-expand-bg.png": "./src/assets/newicons/search-expand-bg.png",
	"./shauxin.png": "./src/assets/newicons/shauxin.png",
	"./sn01.png": "./src/assets/newicons/sn01.png",
	"./sn02.png": "./src/assets/newicons/sn02.png",
	"./sort0.png": "./src/assets/newicons/sort0.png",
	"./sort01.png": "./src/assets/newicons/sort01.png",
	"./yishouc.png": "./src/assets/newicons/yishouc.png",
	"./ylingqu.png": "./src/assets/newicons/ylingqu.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/newicons sync recursive ^\\.\\/.*\\.png$";